import * as echarts from "echarts";
let profileChart = echarts.ECharts;
export default {
  data() {
    return { isFold: false };
  },
  methods: {
    profileChartBox_close() {
      this.$emit("profileChartBox_close");
    },
    draw(option) {
      profileChart.setOption(option);
      profileChart.resize();
    },
    clear() {
      profileChart.clear();
    },
  },
  mounted() {
    profileChart = echarts.init(document.getElementById("profileEchartView"));
  },
  watch: {},
  destroyed() {},
};
